import { AbstractGenericStore } from "./GenericStoreClass";

interface RemovableStore<K, T> {
  remove(key: K): T | undefined;
  removeByValue(value: T): void;
  removeAll(): T[];
}

abstract class AbstractRemovableStore<K, T extends object>
  extends AbstractGenericStore<K, T>
  implements RemovableStore<K, T>
{
  removeAll(): T[] {
    return this.values.splice(0, this.values.length);
  }

  remove(key: K): T | undefined {
    // get value by key
    const value: T | undefined = this.getWithoutLookup(key);

    if (!value) return;

    return this.values.splice(this.values.indexOf(value), 1)[0];
  }

  removeByValue(value: T): void {
    const index: number = this.values.indexOf(value);
    if (index == -1) return;
    this.values.splice(this.values.indexOf(value), 1);
  }
}

export { AbstractRemovableStore, RemovableStore };
